import React, { useState } from 'react';
import { RecoveryAction } from '../services/recoveryService';

interface ErrorRecoveryModalProps {
  isOpen: boolean;
  onClose: () => void;
  error: any;
  recoveryActions: RecoveryAction[];
}

const ErrorRecoveryModal: React.FC<ErrorRecoveryModalProps> = ({
  isOpen,
  onClose,
  error,
  recoveryActions
}) => {
  const [executing, setExecuting] = useState<string | null>(null);

  if (!isOpen) return null;

  const executeAction = async (action: RecoveryAction) => {
    setExecuting(action.id);
    try {
      const success = await action.action();
      if (success) {
        onClose();
      }
    } catch (error) {
      console.error('Recovery action failed:', error);
    } finally {
      setExecuting(null);
    }
  };

  const getSeverityColor = (severity: RecoveryAction['severity']) => {
    switch (severity) {
      case 'high': return 'border-red-300 bg-red-50';
      case 'medium': return 'border-yellow-300 bg-yellow-50';
      default: return 'border-green-300 bg-green-50';
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Bir Sorun Oluştu</h3>
            <p className="text-sm text-gray-600">Aşağıdaki çözümlerden birini deneyebilirsiniz</p>
          </div>
        </div>

        <div className="mb-4 p-3 bg-gray-50 rounded text-sm text-gray-700">
          <strong>Hata:</strong> {error?.message || 'Bilinmeyen hata'}
        </div>

        <div className="space-y-3 mb-6">
          {recoveryActions.map(action => (
            <button
              key={action.id}
              onClick={() => executeAction(action)}
              disabled={executing !== null}
              className={`w-full p-3 border rounded-lg text-left transition-colors ${getSeverityColor(action.severity)} ${
                executing === action.id ? 'opacity-50 cursor-not-allowed' : 'hover:bg-opacity-75'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-gray-900">{action.title}</div>
                  <div className="text-sm text-gray-600">{action.description}</div>
                </div>
                {executing === action.id && (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
                )}
              </div>
            </button>
          ))}
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300 transition-colors"
          >
            İptal
          </button>
          <button
            onClick={() => window.location.reload()}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Sayfayı Yenile
          </button>
        </div>

        <div className="mt-4 text-xs text-gray-500 text-center">
          Sorun devam ederse sistem yöneticisine bildirilmiştir.
        </div>
      </div>
    </div>
  );
};

export default ErrorRecoveryModal;
